













import { defineComponent, onBeforeUnmount, onMounted, reactive, ref, watchEffect } from '@vue/composition-api';
import { createNamespacedHelpers } from 'vuex-composition-helpers';
const { useActions } = createNamespacedHelpers('googleStore');

/* global google */
export default defineComponent({
	props: {
		action: {
			type: String,
			required: true,
		},
		method: {
			type: String,
			required: true,
		},
		icon: {
			type: Boolean,
			required: false,
			default: false,
		},
		googleMapsApiKey: {
			type: String,
		},
		googleMapsClientId: {
			type: String,
		},
	},
	setup(props) {
		const { loadGoogleMapsAPI } = useActions(['loadGoogleMapsAPI']);
		const form = ref(null);
		const api = reactive({ loaded: false });
		function isGoogleMapsConsentGiven() {
			if (typeof (window as any).IsGoogleMapsConsentAvailable === 'function') {
				return (window as any).IsGoogleMapsConsentAvailable();
			}
			return false;
		}
		onMounted(() => {
			if (form.value) {
				const inputElement: HTMLInputElement | null = ((form.value as unknown) as HTMLFormElement).querySelector(
					'.olb-input',
				);
				((form.value as unknown) as HTMLFormElement).addEventListener('submit', (e) => {
					const inputValue = inputElement?.value;
					const geolocationInput = ((form.value as unknown) as HTMLFormElement).querySelector(
						'input[name="geolocation"]',
					);
					e.preventDefault();
					if (api.loaded) {
						const geocoder = new google.maps.Geocoder();
						geocoder.geocode(
							{
								address: `${inputValue}, Deutschland`,
							},
							(results: google.maps.GeocoderResult[] | null, status: google.maps.GeocoderStatus) => {
								if (status === google.maps.GeocoderStatus.OK && results) {
									(geolocationInput as HTMLInputElement).value = `${results[0].geometry.location.lat()},${results[0].geometry.location.lng()}`;
									((form.value as unknown) as HTMLFormElement).submit();
								} else {
									console.log(`Geocoder failed due to: ${status}`);
								}
							},
						);
					}
				});
			}
		});
		watchEffect(() => {
			if (!form.value) {
				return;
			}
			const inputElement: HTMLInputElement | null = ((form.value as unknown) as HTMLFormElement).querySelector(
				'.olb-input',
			);
			if (api.loaded && inputElement) {
				new google.maps.places.Autocomplete(inputElement);
			}
		});
		const consentListener = async () => {
			if (isGoogleMapsConsentGiven()) {
				window.addEventListener('googleMapsAPILoaded', () => {
					if (typeof google === 'object') {
						api.loaded = true;
					}
				});
				loadGoogleMapsAPI({ apiKey: props.googleMapsApiKey, clientId: props.googleMapsClientId });
			}
		};
		onMounted(() => {
			window.addEventListener('GoogleMapsConsentAvailable', consentListener);
		});

		onBeforeUnmount(() => {
			window.removeEventListener('GoogleMapsConsentAvailable', consentListener);
		});
		return { form };
	},
});
